import React from 'react';
import PropTypes from 'prop-types';

import InputInlineEditable from 'core/gd-components/input-inline-editable/input-inline-editable';

import Classes from 'classnames';

export default class NumberInput extends React.Component {

    static propTypes = {
        value: PropTypes.any,
        postfix: PropTypes.string,
        onChange: PropTypes.func,
    };

    state = {
        value: this.props.value,
        invalidValue: false,
        isEditing: false
    };

    constructor(props) {
        super(props);

        this.commited = true;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.commited && this.state.value !== newProps.value) {
            this.updateValue(newProps.value);
        }
    }

    updateValue(val, callback) {
        this.setState({
            value: val,
            invalidValue: !(_.isNil(val) || !isNaN(val) || val.length === 0)
        }, ()=>{if (callback) callback()});
    }

    onFocus = (e) => {
        this.setState({isEditing: true}, () => {
            if (this.props.onFocus) this.props.onFocus(e)
        });
    }

    onBlur = (e) => {
        this.setState({isEditing: false}, () => {
            if (this.props.onBlur) this.props.onBlur(e);
        });
    }

    onChange = (newValue) => {
        this.commited = true;
        let value = parseFloat(!newValue ? '0' : newValue);
        if (isNaN(value)) value = 0;

        this.updateValue(value, ()=>{
            if (this.props.onChange) this.props.onChange(value);
        });
    }

    onImmediateChange = (newValue) => {
        this.commited = false;
        this.updateValue(!newValue ? 0 : newValue);
    }

    onFlush = () => {this.onChange(0)}

    getNormalizedValue() {
        if (this.state.invalidValue) return null;

        const postfixLabel = (!this.state.isEditing && this.props.postfix) ? ' ' + this.props.postfix : '';

        const normalized = typeof this.state.value === 'number' ? this.state.value.toFixed(0) : parseFloat(this.state.value).toFixed(0);
        return ((isNaN(normalized) && !_.isNil(normalized)) || (this.state.isEditing && normalized === '0')) ? null : normalized + postfixLabel;
    }

    render() {
        const classes = Classes('gd-field-number', 'view', 'edit', this.props.className, {
            'invalid-value': this.state.invalidValue,
            'is-editing': this.state.isEditing
        });

        return (
            <div className={classes}>
                <InputInlineEditable ref="input"
                                     value={this.getNormalizedValue()}
                                     onFocus={this.onFocus}
                                     onBlur={this.onBlur}
                                     onChange={this.onChange}
                                     onImmediateChange={this.onImmediateChange}
                                     commitDelay={500} />
                <div className="delete-button i5-delete-circle-solid" onClick={this.onFlush}/>
            </div>
        );
    }
}